export default __webpack_public_path__ + "static/media/04_photo.d87089c9.jpg";